<template>
  <div class="sidebar-navigation">
    <div class="grid grid-cols-1 gap-4">
      <div class="col-span-1">
        <font-awesome-icon
          title="Close menu"
          class="float-right mb-6 mr-2 text-xl text-gray-300 transition-all duration-200 ease-in-out cursor-pointer hover:text-white"
          icon="angles-left"
          @click="navToggle()"
        />
      </div>
    </div>
    <div class="grid grid-cols-1 gap-4">
      <div class="col-span-1">
        <Accordion :multiple="true">
          <AccordionTab
            v-for="tierOneItem in navItems.filter(item => !item.hidden)"
            :key="tierOneItem.name"
            :disabled="tierOneItem.disabled"
          >
            <template #header>
              <font-awesome-icon
                v-if="tierOneItem.icon"
                :icon="tierOneItem.icon.name"
                :class="tierOneItem.icon.class"
              />
              <span class="ml-4">{{tierOneItem.name}}</span>
            </template>
            <Accordion v-if="tierOneItem.items.items" :multiple="true">
              <AccordionTab
                v-for="tierTwoItem in tierOneItem.items.filter(item => !item.hidden)"
                :key="tierTwoItem.name"
                :header="tierTwoItem.name"
                :disabled="tierTwoItem.disabled"
              ></AccordionTab>
            </Accordion>
            <div v-else>
              <div
                v-for="tierTwoItem in tierOneItem.items.filter(item => !item.hidden)"
                :key="tierTwoItem.name"
              >
                <div v-if="tierTwoItem.to">
                  <router-link
                    :to="tierTwoItem.to"
                    :class="[
                      tierTwoItem.current
                        ? 'nav-selected-bg text-white'
                        : 'text-gray-450 hover:bg-rms-primary-lighter hover:text-white',
                      'group w-full flex flex-col text-xs font-medium pt-2 pb-2 pl-2 pr-2',
                    ]"
                    :aria-current="tierTwoItem.current ? 'page' : undefined"
                    @click="$emit('onClick', [tierOneItem, tierTwoItem])"
                  >
                    <div class="text-left">
                      <div class="float-left">
                        <span class="mt-2">{{ tierTwoItem.name }}</span>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div v-else-if="tierTwoItem.routeName">
                  <router-link
                    :to="{ name: tierTwoItem.routeName, params: tierTwoItem.params }"
                    :class="[
                      tierTwoItem.current
                        ? 'nav-selected-bg text-white'
                        : 'text-gray-450 hover:bg-rms-primary-lighter hover:text-white',
                      'group w-full flex flex-col text-xs font-medium pt-2 pb-2 pl-2 pr-2',
                    ]"
                    :aria-current="tierTwoItem.current ? 'page' : undefined"
                    @click="$emit('onClick', [tierOneItem, tierTwoItem])"
                  >
                    <div class="text-left">
                      <div class="float-left">
                        <span class="mt-2">{{ tierTwoItem.name }}</span>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </AccordionTab>
        </Accordion>
      </div>
    </div>
  </div>
</template>

<script>
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'

export default {
  components: {
    Accordion,
    AccordionTab,
  },
  props: {
    navItems: {
      type: Array,
      default: () => [],
    },
    navToggle: {
      type: Function,
      default: () => null,
    },
  },
  emits: ['onClick'],
  setup() {
    return {}
  },
}
</script>
